import store from '../store/index'
//------------
// get config
//------------
export default function getConfig() {
  const config = store.getters['combat/getConfig']

  return typeof config === 'function' ? config() : config
}
